__webpack_require__.p = "https://cdn.medprev.online/web-app/assets/ad3772d8/_next/";